import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { SimpleCache } from '../../../utils/simple-cache';
import { timed } from '../timing';
export var CollaborationGraph = /*#__PURE__*/function () {
  function CollaborationGraph(_ref) {
    var url = _ref.url;
    _classCallCheck(this, CollaborationGraph);
    this.serviceConfig = {
      url: url
    };
    this.getContainersSupplier = this.getContainersSupplier.bind(this);
    this.getUsersSupplier = this.getUsersSupplier.bind(this);
    this.containersCache = new SimpleCache(this.getContainersSupplier);
    this.usersCache = new SimpleCache(this.getUsersSupplier);
  }
  _createClass(CollaborationGraph, [{
    key: "makeRequest",
    value: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, body) {
        var options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = {
                path: path,
                requestInit: {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  credentials: 'include',
                  body: JSON.stringify(body)
                }
              };
              return _context.abrupt("return", timed(utils.requestService(this.serviceConfig, options)));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function makeRequest(_x, _x2) {
        return _makeRequest.apply(this, arguments);
      }
      return makeRequest;
    }()
  }]);
  return CollaborationGraph;
}();